export default {"src":"/_next/static/media/logob6_3.2a00a756.svg","height":79,"width":200,"blurWidth":0,"blurHeight":0};